if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class stickyCartModal extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = document.getElementById(`product-form-${this.dataset.section}`);
    this.host = document.getElementById(`MainProduct-${this.dataset.section}`);
    if (!this.form || !this.host) return;
    this.pending = false;
    this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); }); };
    this.change = event => {
      if (event.target.closest('variant-selects, variant-radios')) this.pending = true;
      this.schedule();
    };
    this.host.addEventListener('change', this.change);
    this.host.addEventListener('am:purchase-updated', this.schedule);
    window.addEventListener('scroll', this.schedule, { passive: true });
    window.addEventListener('resize', this.schedule, { passive: true });
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(this.host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
    this.bodyObserver = new MutationObserver(this.schedule);
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (event?.data?.sectionId === this.dataset.section) { this.pending = false; this.schedule(); }
    });
    document.querySelector('footer')?.classList.add('sticky-cart-modal_bottom_padding');
    this.update();
  }
  disconnectedCallback() {
    this.ready = false;
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect(); this.bodyObserver?.disconnect(); this.unsubscribe?.();
    this.host?.removeEventListener('change', this.change);
    this.host?.removeEventListener('am:purchase-updated', this.schedule);
    window.removeEventListener('scroll', this.schedule); window.removeEventListener('resize', this.schedule);
    document.body.classList.remove('modal__sticky-cart');
  }
  text(element, value) { if (element && element.textContent !== value) element.textContent = value; }
  update() {
    const mainButton = this.form.querySelector('[name="add"]');
    const stickyButton = this.querySelector('[data-am-sticky-submit]');
    if (!mainButton || !stickyButton) return;
    const busy = this.pending || mainButton.getAttribute('aria-disabled') === 'true';
    const disabled = busy || mainButton.disabled;
    if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
    this.text(stickyButton.querySelector('span'), this.pending ? stickyButton.dataset.pendingLabel : mainButton.disabled ? stickyButton.dataset.soldLabel : stickyButton.dataset.addLabel);
    const formData = new FormData(this.form);
    const planId = String(formData.get('selling_plan') || '');
    const details = this.host.querySelector('am-purchase-options');
    const plan = details && Array.from(details.querySelectorAll('[data-am-plan]')).find(card => card.dataset.amPlan === planId);
    const nativePrice = this.host.querySelector('[id^="price-"] .price__main__value');
    this.text(this.querySelector('[data-am-sticky-price]'), plan?.dataset.amPlanPrice || details?.dataset.basePrice || nativePrice?.textContent.trim() || '');
    this.text(this.querySelector('[data-am-sticky-mode]'), plan?.dataset.amPlanName || (details ? details.dataset.baseLabel : ''));
    this.text(this.querySelector('[data-am-sticky-quantity]'), stickyButton.dataset.quantityLabel + ': ' + (formData.get('quantity') || '1'));
    const modalOpen = !!document.querySelector('cart-drawer.active, cart-drawer[open], .cart-drawer.active, dialog[open], .menu-drawer-container[open]') || document.body.classList.contains('am-cart-focused') || document.body.classList.contains('overflow-hidden');
    const shown = mainButton.getBoundingClientRect().bottom <= 0 && !modalOpen;
    if (this.classList.contains('show-modal') !== shown) this.classList.toggle('show-modal', shown);
    if (document.body.classList.contains('modal__sticky-cart') !== shown) document.body.classList.toggle('modal__sticky-cart', shown);
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
